import React from 'react';

const CoupleIcon = (props) => (
  <svg height='32' width='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(6 8)'>
        <path d='m14 13v2h-14v-2s0-4 7-4 7 4 7 4m-3.5-9.5c0-1.933-1.567-3.5-3.5-3.5s-3.5 1.567-3.5 3.5c0 1.933 1.567 3.5 3.5 3.5s3.5-1.567 3.5-3.5m3.44 5.5c1.2444 0.96306 1.9987 2.4276 2.06 4v2h4v-2s0-3.63-6.06-4m-0.94-9.0001c-0.68831-0.0037801-1.3615 0.20201-1.93 0.59005 1.2454 1.7401 1.2454 4.0799 0 5.82 0.56852 0.38804 1.2417 0.59383 1.93 0.59005 1.933 0 3.5-1.5671 3.5-3.5001 0-1.933-1.567-3.5001-3.5-3.5001z' />
      </g>
    </g>
  </svg>
);

export default CoupleIcon;
